import Card from "@mui/material/Card";
import { FunctionField, NumberField, RecordContextProvider } from "react-admin";
import { useParams } from "react-router-dom";

import {
  AccountUserCountResponse,
  Action,
  DataKind,
  Resource,
} from "../../types";
import {
  Authorize,
  CustomDatagrid,
  CustomDateTimeField,
  CustomReferenceManyField,
  TitleRow,
} from "../custom";

function AccountHistory() {
  const { account_id } = useParams();

  return (
    <Authorize action={Action.Read} dataKind={DataKind.AccountUserCount}>
      <RecordContextProvider value={{ id: account_id }}>
        <TitleRow title="Account History" />
        <CustomReferenceManyField
          displayPagination={true}
          label={false}
          reference={Resource.AccountUserCount}
          target={Resource.Account}
        >
          <Card>
            {/*
              We disable row click as there is no associated show page for
              the account user count resource. Navigating to the show page
              for the underlying resource is our current default upon a
              datagrid row click!
            */}
            <CustomDatagrid disableRowClick={true}>
              <CustomDateTimeField label="Date" source="date" />
              <NumberField label="Count" source="active_users" />
              <FunctionField
                label="Users"
                render={(record: AccountUserCountResponse) =>
                  record.user_infos
                    ?.map((i) => i.email)
                    .sort((e1, e2) => e1.localeCompare(e2))
                    .join(", ")
                }
                sortable={false}
              />
            </CustomDatagrid>
          </Card>
        </CustomReferenceManyField>
      </RecordContextProvider>
    </Authorize>
  );
}

export default AccountHistory;
